import Upload from './src/index.vue';

/* istanbul ignore next */
(Upload as any).install = function(Vue: any) {
  Vue.component(Upload.name, Upload);
};

export default Upload;
